(() => {
  const scenes = {
    trail: ['ON THE TRAIL', 'Pause. Look a little closer.', 'Explore field optics for the landscapes and details along the way.', '#optics', 'Explore optics ↗'],
    camp: ['AT THE CAMPSITE', 'Stay for the last light.', 'Explore camp lighting for evenings around your outdoor setup.', '#lighting', 'Explore lighting ↗'],
    road: ['ON THE ROAD', 'Take the long way home.', 'Explore portable power for the devices you bring along. Check capacity and output against your needs.', '#power', 'Explore portable power ↗']
  };
  function init(root) {
    root.querySelectorAll('[data-field-store]').forEach(store => {
      if (store.dataset.ready) return;
      store.dataset.ready = 'true';
      store.querySelectorAll('[data-scene]').forEach(button => button.addEventListener('click', () => {
        const content = scenes[button.dataset.scene];
        store.querySelectorAll('[data-scene]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        ['label', 'heading', 'copy'].forEach((key, i) => { store.querySelector('[data-scene-' + key + ']').textContent = content[i]; });
        const link = store.querySelector('[data-scene-link]');
        link.href = content[3]; link.textContent = content[4];
      }));
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#field-detail-"]');
    if (link) {
      const detail = document.getElementById(link.getAttribute('href').slice(1));
      if (detail) detail.open = true;
    }
    const mobileLink = event.target.closest('.ot-mobile-nav a');
    if (mobileLink) mobileLink.closest('details').open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const menu = document.querySelector('.ot-header details[open]');
      if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
    }
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();